import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Tabs,
} from "antd";
import { useState } from "react";
import MainLayout from "../../../components/mainLayout";
import "./index.scss";
import Upload from '../../../commons/Upload';
import BannerForm from '../../../components/form/bannerForm';
import { authApis } from "../../../services/authApi";
import { nofication } from '../../../commons/Nofication';
import { useParams } from 'react-router-dom';
import { ROOT_URL } from "../../../constants/api";
import BackButton from "../../../commons/BackButton";
import { useNavigate } from 'react-router-dom';

const { TabPane } = Tabs;
const style = { padding: "8px 20px" };
const onChange = (key) => {
    console.log(key);
};

const Register = () => {
    const history = useNavigate();
    const [fileList, setFileList] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [form] = Form.useForm();
    let { id } = useParams();
    const [content, setContent] = useState({
        content_vi: "",
        content_en: "",
        content_kr: "",
        content_cn: "",
        content_jp: "",
    });
    const onChangeContentValue = (lang) => {
        console.log('lang')
    }
    useState(() => {
        if (id) {
            authApis
            .getDetailBanner(id + '?type=4')
            .then((data) => {
                if (data.status_code === 200) {
                    form.setFieldsValue(data.banner)
                    setImageUrl(data.banner?.image ? ROOT_URL + data.banner.image : '')
                    setContent({
                        content_vi: data.banner?.content_vi ?? '<p></p>',
                        content_en: data.banner?.content_en ?? '<p></p>',
                        content_kr: data.banner?.content_kr ?? '<p></p>',
                        content_cn: data.banner?.content_cn ?? '<p></p>',
                        content_jp: data.banner?.content_jp ?? '<p></p>',
                    });
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
        }
    })

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (key === 'content_vi' || key === 'content_en' || key === 'content_kr' || key === 'content_cn' || key === 'content_jp') {
                formData.append(key, values[key]?.editor ? values[key]?.editor.getData() : values[key]);
            } else {
                formData.append(key, values[key]);
            }
        }
        id && formData.append('id', id);
        formData.append('logo', fileList)
        formData.append('type', 4)
        await authApis
            .banner(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                    history('/why-choose/inverstment/list');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Inverstment"
            link="/why-choose/"
            titleNew="Why choose / Inverstment / Create"
        >
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true}>
                <Row gutter={16}>
                    <Col span={24} className='pad'>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <BannerForm lang={'vi'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng anh" key="2">
                                    <BannerForm lang={'en'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng hàn" key="3">
                                    <BannerForm lang={'kr'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng trung" key="4">
                                    <BannerForm lang={'cn'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng nhật" key="5">
                                    <BannerForm lang={'jp'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                            </Tabs>
                            <Form.Item label="Thumnail" colon={true}>
                                <Upload imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} span={24} />
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton/>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
